import { SellOutlined, ShoppingCart } from "@mui/icons-material";
import { Box, Button, Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const OfferContent = ({
  hours,
  minutes,
  seconds,
  endDate,
  endTime,
  offerUSD,
  offerEth,
}) => {
  const [remainingTime, setRemainingTime] = useState({
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  });

  useEffect(() => {
    let totalSeconds = hours * 3600 + minutes * 60 + seconds;

    const timer = setInterval(() => {
      if (totalSeconds < 0) {
        clearInterval(timer);
        console.log("Countdown complete!");
      } else {
        const remainingHours = Math.floor(totalSeconds / 3600);
        const remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
        const remainingSeconds = totalSeconds % 60;

        setRemainingTime({
          hours: remainingHours,
          minutes: remainingMinutes,
          seconds: remainingSeconds,
        });

        totalSeconds--;
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [hours, minutes, seconds]);

  return (
    <Box
      ml={2}
      sx={{
        border: "1px solid lightgray",
        width: "95%",
        p: 3,
        borderRadius: "10px",
        bgcolor: "#FBFDFF",
      }}
    >
      <Box>
        <Box>
          <Typography color={"gray"} pb={1}>
            Sales ends {endDate} at {endTime}
          </Typography>
          <Box sx={{ display: "flex" }} my={1}>
            <Box>
              <Typography fontWeight={"bold"}>{remainingTime.hours}</Typography>
              <Typography variant='caption' sx={{ color: "gray" }}>
                Hours
              </Typography>
            </Box>
            <Box mx={8}>
              <Typography fontWeight={"bold"}>
                {remainingTime.minutes}
              </Typography>
              <Typography variant='caption' sx={{ color: "gray" }}>
                Minutes
              </Typography>
            </Box>
            <Box>
              <Typography fontWeight={"bold"}>
                {remainingTime.seconds}
              </Typography>
              <Typography variant='caption' sx={{ color: "gray" }}>
                Seconds
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider />
        <Typography sx={{ textTransform: "none", color: "gray" }}>
          Best Offer
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant='h4' fontWeight={"bold"} color={"black"}>
          {offerEth}
        </Typography>
        <Typography color={"gray"}>${offerUSD}</Typography>
      </Box>
      <Box sx={{ display: "flex" }}>
        <Button
          variant={"contained"}
          fullWidth
          sx={{ mr: 1, textTransform: "none" }}
          endIcon={<ShoppingCart />}
        >
          Buy now
        </Button>
        <Button
          fullWidth
          sx={{
            textTransform: "none",
            fontWeight: "bold",
            border: "1px solid lightgray",
          }}
          startIcon={<SellOutlined />}
          variant='outlined'
        >
          Make offer
        </Button>
      </Box>
    </Box>
  );
};

export default OfferContent;
